import { useContext, useEffect, useState } from 'react';

// material-ui
import { Button, Grid, Typography } from '@mui/material';

// project imports
import { gridSpacing } from '../../store/constant';

import { ContextNotification, severitys } from '../../App';

import UserApi from '../../api/UserApi';
import applicationApi from '../../api/applicationApi';
import DarkCard from '../../Components/DarkCard';


//menu icons
import { FaUserCog } from "react-icons/fa";
import { SiHotelsdotcom } from "react-icons/si";
import { MdEmojiTransportation } from "react-icons/md";
import { MdAssignmentInd } from "react-icons/md";
import { IoApps } from "react-icons/io5";
import { useParams } from 'react-router-dom';
import { FaCcVisa } from "react-icons/fa";
import { RiSurveyFill } from "react-icons/ri";
import { MdCardTravel } from "react-icons/md";
// meta export
export const meta = () => ({
  title: 'داشبورد سامانه ها',
  description:
    ''
});

// ==============================|| DEFAULT DASHBOARD ||============================== //

const HomePage = () => {
  const [isLoading, setLoading] = useState(true);
  const [appList, setAppList] = useState([]);
  const [userRole, setUserRole] = useState('');
  const { setOpen } = useContext(ContextNotification);
  const { key = '' } = useParams()

  useEffect(() => {
    setLoading(false);
    GetAppList();
    GetUserRole();
  }, []);
  const GetUserRole = () => {
    if (key.trim() !== '')
      setUserRole(key)
    else {
      UserApi.GetPermissions()
        .then(async (data) => {
          setUserRole(data.data.roles[0])
        }
        ).catch((err) => {
          console.log(err)
        })
    }
  }
  const GetAppList = () => {

    return applicationApi.GetAppList()
      .then((data) => {
        setAppList(data.data.filter(app => (app.id !== 5)));

      })
      .catch(err => {

        if (err.response && err.response.data) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
        }
        else if (err.response && err.response.data && err.response.data.errors) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
        else if (err.message) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
        }

      }
      );
  };
  const getIcon = (appid) => {

    switch (appid) {
      case 1:
        return <FaUserCog />;
      case 2:
        return <SiHotelsdotcom />;
      case 3:
        return <MdEmojiTransportation />;
      case 4:
        return <MdAssignmentInd />;
      case 7:
        return <FaCcVisa />;
      case 8:
        return <RiSurveyFill />
      case 9:
        return <MdCardTravel />
      default:
        return <IoApps />;
    }
  }

  return (



    <>
      <Grid container spacing={gridSpacing} sx={{ direction: 'rtl' }}>

        <Grid item xs={12}>
          <Grid container spacing={gridSpacing}>
            {appList.sort((a, b) => a.id > b.id ? 1 : -1).map((value, index) => {
              return (<Grid item lg={4} md={6} sm={6} xs={12}  >
                <DarkCard dark={index % 2 == 0 ? true : false} icon={getIcon(value.id)} isLoading={isLoading} title={value.persianName} descrypion={''}
                  domain={value.domain?.trimEnd('/')} RoleName={userRole} />
              </Grid>)
            })
            }
          </Grid>

        </Grid>

      </Grid>

    </>
  );
};

export default HomePage;
